import { FlexProps } from '../../layout/Flex';

export interface ContentPromotionDateProps extends FlexProps {
    value: ContentPromotionDateValue;
    date: string;
    startDate: Date;
    onChange: (value: ContentPromotionDateValue) => void;
    onChangeDate: (value: string) => void;
}

export enum ContentPromotionDateValue {
    NOW = 'now',
    CHOICE = 'choice',
}
